import http from "./http-common";

const getAll = (params = {}) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return http.get(`/assets${qs ? `?${qs}` : ''}`);
};

const get = id => {
  return http.get(`/assets/${id}`);
};

const create = data => {
  return http.post("/assets", data);
};

const update = (id, data) => {
  return http.put(`/assets/${id}`, data);
};

const remove = id => {
  return http.delete(`/assets/${id}`);
};

const removeAttachment = (id, attachmentId) => {
  return http.delete(`/assets/${id}/attachments/${attachmentId}`);
};

const removeAll = () => {
  return http.delete(`/assets`);
};

const findByTitle = title => {
  return http.get(`/assets?title=${title}`);
};

const AssetService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAttachment,
  removeAll,
  findByTitle
};

export default AssetService;